import { ReasonCode } from "types/landlord/reports";
import {
  AdditionalData,
  BankStatementItem,
  VerifiedBankStatement
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank-statment";

const getRejectionChecks = (
  additionalData?: AdditionalData,
  usedItems?: BankStatementItem[]
) => [
  {
    condition: additionalData?.type_mismatch,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "The document is not a bank statement"
    }
  },
  {
    condition: additionalData?.is_fraudulent,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "Fraudulent activity detected"
    }
  },
  {
    condition: additionalData?.high_risk_level,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "High risk level"
    }
  },
  {
    condition: additionalData?.low_trust_score,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "Low trust score"
    }
  },
  {
    condition: additionalData?.low_quality_score,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "The file is of poor quality"
    }
  },
  {
    condition:
      !additionalData?.bank_statement_start_date ||
      !additionalData.bank_statement_end_date,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "Document dates are missing"
    }
  },
  {
    condition:
      !additionalData?.earliest_transaction_date &&
      !additionalData?.latest_transaction_date,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "Transaction dates are missing"
    }
  },
  {
    condition: !additionalData?.is_name_present,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "No account holder name present on document"
    }
  },
  {
    condition: !usedItems?.map((i) => i.data?.transaction)?.length,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "No transactions for the required period"
    }
  }
];

export const getBankStatementReasonCodes = (
  bankStatement?: Partial<VerifiedBankStatement> & {
    usedItems?: BankStatementItem[];
  }
): ReasonCode[] => {
  if (!bankStatement) return [];

  const { additional_data: additionalData, usedItems } = bankStatement;
  const warnings: ReasonCode[] = [];

  const checks = getRejectionChecks(additionalData, usedItems);
  checks.forEach(({ condition, reasonCode }) => {
    if (condition) warnings.push(reasonCode);
  });

  return warnings;
};
